// import * as DropdownMenu from "zeego/dropdown-menu";
// import { Text, Pressable } from "react-native";
// import {
//   ContextButtonProps,
//   GenericDropdownMenuProps,
//   MenuItem,
//   MenuItemType,
// } from "./types";
// import {
//   defaultButtonStyles,
//   defaultTextStyles,
//   sizeStyles,
//   textSizeStyles,
// } from "./styles";
// import {
//   isCheckboxItem,
//   isMenuGroup,
//   isSeparator,
//   isSubMenuItem,
// } from "./helpers";

// export function ContextButton({
//   title,
//   onPress,
//   style,
//   textStyle,
//   disabled = false,
//   variant = "primary",
//   size = "medium",
// }: ContextButtonProps) {
//   const buttonStyle = [
//     defaultButtonStyles[variant],
//     sizeStyles[size],
//     disabled && { opacity: 0.5 },
//     style,
//   ];

//   const buttonTextStyle = [
//     defaultTextStyles[variant],
//     textSizeStyles[size],
//     textStyle,
//   ];

//   return (
//     <Pressable
//       style={buttonStyle}
//       onPress={onPress}
//       disabled={disabled}
//       accessibilityRole="button"
//       accessibilityLabel={title}
//     >
//       <Text style={buttonTextStyle}>{title}</Text>
//     </Pressable>
//   );
// }

// export function GenericDropdownMenu({
//   trigger,
//   items,
//   label,
//   showArrow = false,
//   disabled = false,
// }: GenericDropdownMenuProps) {
//   const renderMenuItem = (item: MenuItemType, index: number) => {
//     if (isSeparator(item)) {
//       return <DropdownMenu.Separator key={`separator-${index}`} />;
//     }

//     if (isMenuGroup(item)) {
//       return (
//         <DropdownMenu.Group key={`group-${index}`}>
//           {item.items.map((groupItem) => (
//             <DropdownMenu.Item
//               key={groupItem.key}
//               onSelect={groupItem.onSelect}
//               destructive={groupItem.destructive}
//               disabled={groupItem.disabled}
//             >
//               <DropdownMenu.ItemTitle>{groupItem.title}</DropdownMenu.ItemTitle>
//             </DropdownMenu.Item>
//           ))}
//         </DropdownMenu.Group>
//       );
//     }

//     if (isSubMenuItem(item)) {
//       return (
//         <DropdownMenu.Sub key={item.key}>
//           <DropdownMenu.SubTrigger key={`${item.key}-trigger`}>
//             <DropdownMenu.ItemTitle>{item.title}</DropdownMenu.ItemTitle>
//           </DropdownMenu.SubTrigger>
//           <DropdownMenu.SubContent>
//             {item.items.map((subItem) => (
//               <DropdownMenu.Item
//                 key={subItem.key}
//                 onSelect={subItem.onSelect}
//                 destructive={subItem.destructive}
//                 disabled={subItem.disabled}
//               >
//                 <DropdownMenu.ItemTitle>{subItem.title}</DropdownMenu.ItemTitle>
//               </DropdownMenu.Item>
//             ))}
//           </DropdownMenu.SubContent>
//         </DropdownMenu.Sub>
//       );
//     }

//     if (isCheckboxItem(item)) {
//       return (
//         <DropdownMenu.CheckboxItem
//           key={item.key}
//           value={item.key as "mixed" | "on" | "off"}
//           checked={item.checked}
//           onSelect={item.onSelect}
//           disabled={item.disabled}
//         >
//           <DropdownMenu.ItemIndicator>
//             {item.indicator || "✔"}
//           </DropdownMenu.ItemIndicator>
//           <DropdownMenu.ItemTitle>{item.title}</DropdownMenu.ItemTitle>
//         </DropdownMenu.CheckboxItem>
//       );
//     }

//     const regularItem = item as MenuItem;
//     return (
//       <DropdownMenu.Item
//         key={regularItem.key}
//         onSelect={regularItem.onSelect}
//         destructive={regularItem.destructive}
//         disabled={regularItem.disabled}
//       >
//         <DropdownMenu.ItemTitle>{regularItem.title}</DropdownMenu.ItemTitle>
//       </DropdownMenu.Item>
//     );
//   };

//   return (
//     <DropdownMenu.Root>
//       <DropdownMenu.Trigger disabled={disabled}>{trigger}</DropdownMenu.Trigger>

//       <DropdownMenu.Content>
//         {label && <DropdownMenu.Label>{label}</DropdownMenu.Label>}

//         {items.map((item, index) => renderMenuItem(item, index))}

//         {showArrow && <DropdownMenu.Arrow />}
//       </DropdownMenu.Content>
//     </DropdownMenu.Root>
//   );
// }

import React from "react";
import { StyleSheet, Text, View } from "react-native";

const ContextMenu = () => {
  return (
    <View>
      <Text>ContextMenu</Text>
    </View>
  );
};

export default ContextMenu;

const styles = StyleSheet.create({});
